import { useEffect, useState } from "react";
import { json, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  ProductFilterProductsDontColor,
  ProductFilterBerand,
  CompetitorPackeageSetAmountPackeage,
  CompetitorPackeageEditeAmountPackeage,
  CompetitorPackeageHistoryPackeage,
  CompetitorMyCompetitor,
} from "../../Api/Services";
import InputCus from "../../Component/InputCus/Text/InputCus";
import ComponentPricePackeageAE from "./ComponentPricePackeageAE";
import Select from "../../Component/InputCus/Select/Select";

function CompetitorPriceCopy() {
  const [isLoading, setLoading] = useState(true);
  const [Product, setProduct] = useState([]);
  const [Description, setDescription] = useState("");
  const [CompetitorId, setCompetitorId] = useState();
  const [Title, setTitle] = useState("");
  const [Amounts, setAmounts] = useState([]);
  const [AmountsBase, setAmountsBase] = useState([]);
  const [brands, setBrands] = useState([]);
  const [activeItem, setActiveItem] = useState(null);
  const navigate = useNavigate();
  let { id, extra } = useParams();
  const [DataCompetitorBase, setDataCompetitorBase] = useState([]);
  const [DataCompetitor, setDataCompetitor] = useState([]);
  const [SearchName, setSearchName] = useState("");

  const start = async () => {
    try {
      const ProductFilterProductsDontColorData =
        await ProductFilterProductsDontColor();
      if (
        ProductFilterProductsDontColorData.status &&
        ProductFilterProductsDontColorData.status === 200
      ) {
        setProduct(ProductFilterProductsDontColorData.data.data.data);
        const ProductFilterBerandData = await ProductFilterBerand({});
        if (
          ProductFilterBerandData.status &&
          ProductFilterBerandData.status === 200
        ) {
          setBrands(ProductFilterBerandData.data.data.data);

          if (extra) {
            const CompetitorPackeageHistoryPackeageData =
              await CompetitorPackeageHistoryPackeage(extra);
            if (
              CompetitorPackeageHistoryPackeageData.status &&
              CompetitorPackeageHistoryPackeageData.status === 200
            ) {
              let copy = [];
              CompetitorPackeageHistoryPackeageData.data.data.prices.map(
                (e) => {
                  let data = {
                    Id: e.productId,
                    Price: e.price,
                    Count: e.count,
                  };
                  copy.push(data);
                },
              );
              setAmounts(JSON.parse(JSON.stringify(copy)));
              setAmountsBase(JSON.parse(JSON.stringify(copy)));
              setTitle(CompetitorPackeageHistoryPackeageData.data.data.title);
              setDescription(
                CompetitorPackeageHistoryPackeageData.data.data.description,
              );
              const CompetitorMyCompetitorData = await CompetitorMyCompetitor();
              if (
                CompetitorMyCompetitorData.status &&
                CompetitorMyCompetitorData.status === 200
              ) {
                setDataCompetitor(CompetitorMyCompetitorData.data.data.data);
                DataCompetitorBase(CompetitorMyCompetitorData.data.data.data);
              }
            }
          }
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const handleClick = (key) => {
    setActiveItem(activeItem === key ? null : key);
  };

  const setDar = (idBerand, e) => {
    if (e.target.value == 0) {
      const Copy = [...Amounts];
      let pp = Product.filter((q) => q.productBerandId == idBerand).map(
        (w) => w.id,
      );
      console.log(Copy);
      Copy.filter((w) => pp.includes(w.Id)).map((e) => {
        e.Price = 0;
        e.Count = 0;
      });
      console.log(Copy);

      setAmounts(Copy);
    }
    if (e.target.value == "") {
      const Copy = [...Amounts];
      const copyAmountsBase = JSON.parse(JSON.stringify(AmountsBase));
      Product.filter(
        (q) =>
          q.productBerandId == idBerand &&
          copyAmountsBase.find((w) => w.Id == q.id),
      ).map((element) => {
        let pp = copyAmountsBase.find((w) => w.Id == element.id);
        let aa = Copy.find((w) => w.Id == element.id);
        if (aa) {
          aa.Price = pp.Price;
          aa.Count = pp.Count;
        } else {
          Copy.push(pp);
        }
      });
      setAmounts(Copy);
    }
    if (e.target.value != 0 && e.target.value != "") {
      let dar = e.target.value / 100 + 1;
      const Copy = [...Amounts];
      const copyAmountsBase = JSON.parse(JSON.stringify(AmountsBase));
      Product.filter(
        (q) =>
          q.productBerandId == idBerand &&
          copyAmountsBase.find((w) => w.Id == q.id),
      ).map((element) => {
        let pp = copyAmountsBase.find((w) => w.Id == element.id);
        let p = pp.Price * dar;

        let aa = Copy.find((w) => w.Id == element.id);
        if (aa) {
          aa.Price = Math.floor(p);
          aa.Count = pp.Count;
        } else {
          let data = {
            Id: pp.productId,
            Price: Math.floor(p),
            Count: pp.count,
          };
          Copy.push(data);
        }

        Copy.find((w) => w.Id == element.id).Price = Math.floor(p);
      });
      setAmounts(Copy);
    }
  };

  function isEmpty(value) {
    return value == null || value == undefined || value == "" || value == 0;
  }

  const Add = async () => {
    let validation = true;

    const data = [...Amounts].filter(
      (item) => !(isEmpty(item.Price) && isEmpty(item.Count)),
    );
    let check = data.filter((w) => isEmpty(w.Price) || isEmpty(w.Count));
    if (check.length > 0) {
      toast.error("لطفا برای هر کالا هم قیمت هم تعداد را وارد نمایید");
      validation = false;
    }
    if (validation) {
      setLoading(true);
      try {
        const CompetitorPackeageSetAmountPackeageData =
          await CompetitorPackeageSetAmountPackeage({
            data: data,
            competitorId: CompetitorId,
            title: Title,
            description: Description,
          });
        if (
          CompetitorPackeageSetAmountPackeageData.status &&
          CompetitorPackeageSetAmountPackeageData.status === 200
        ) {
          toast.success("افزودن  قیمت با موفقیت انجام شد");
          navigate("/Panel/CompetitorPrice");
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-end align-items-center m-2 w-100">
            <button onClick={Add} className="butAU">
              {extra ? "ویرایش" : "افزودن"}
            </button>
          </div>
          <div className="d-flex justify-content-start align-items-center flex-column m-2 w-100">
            <InputCus
              className="m-2"
              type="text"
              name="Title"
              id="Title"
              text="نام"
              value={Title}
              onChange={(w) => {
                setTitle(w.target.value);
              }}
            />
            <InputCus
              className="m-2"
              type="text"
              name="Description"
              id="Description"
              text="توضیحات"
              value={Description}
              onChange={(w) => {
                setDescription(w.target.value);
              }}
            />
            <div className="d-flex">
              <InputCus
                className="m-2"
                type="text"
                name="name"
                id="name"
                text="جست وجو مراجع"
                value={SearchName}
                onChange={(e) => {
                  setSearchName(e.target.value);
                }}
              />
              <Select
                className="m-2"
                type="number"
                name="competitorId"
                id="competitorId"
                text="مرجع"
                value={DataCompetitor.find((w) => w.id == CompetitorId)?.id}
                onChange={(e) => {
                  setCompetitorId(e.target.value);
                }}
                option={DataCompetitor.filter((w) =>
                  w.name?.toLowerCase?.().includes(SearchName.toLowerCase()),
                ).map((item) => {
                  let data = {
                    value: item.id,
                    title: item.name+"("+item.competitorCategoryName+")",
                  };
                  return data;
                })}
              />
            </div>
          </div>

          {brands.map(
            (b, key) =>
              Product.filter((e) => e.productBerandId == b.id).length > 0 && (
                <>
                  <div
                    key={b}
                    className="d-flex justify-content-around align-items-center w-100 p-3 mt-4 pointer bg-body-secondary border border-1 border-black"
                    onClick={() => handleClick(b.id)}
                  >
                    <h5>{b.name}</h5>
                    <InputCus
                      className="m-2"
                      type="text"
                      name="درصد"
                      text="درصد"
                      onChange={(e) => {
                        setDar(b.id, e);
                      }}
                    />
                  </div>
                  {activeItem === b.id && (
                    <ComponentPricePackeageAE
                      key={key}
                      Product={Product.filter((e) => e.productBerandId == b.id)}
                      Amounts={Amounts}
                      setAmounts={setAmounts}
                    />
                  )}
                </>
              ),
          )}

          <div className="d-flex justify-content-start align-items-center w-100 m-5">
            <button onClick={Add} className="butAU">
              {extra ? "ویرایش" : "افزودن"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompetitorPriceCopy;
